<template>
    <div class="im-head">
        <el-row class="navbar" mode="horizontal">
            <hamburger class="hamburger-container" :toggleClick="toggleSideBar" :isActive="sidebar.opened"></hamburger>
            <div class="avatar-container">
                <el-badge class="item msg-tip" :value="$store.getters.msgNum">
                    <router-link :to="{path: '/message'}"><i class="el-icon-message"></i></router-link>
                </el-badge>
            </div>
            <el-dropdown class="avatar-container" trigger="click">
                <div class="avatar-wrapper">
                    <img class="user-avatar" src="../assets/avatar.png">
                    <i class="el-icon-caret-bottom"></i>
                </div>
                <el-dropdown-menu class="user-dropdown" slot="dropdown">
                    <el-dropdown-item>
                    <span>
                        <router-link :to="{path: '/users/view', query: {id: $store.getters.userId}}">个人资料</router-link>
                    </span>
                    </el-dropdown-item>
                    <el-dropdown-item>
                    <span>
                        <router-link :to="{path: '/users/change-pwd', query: {id: $store.getters.userId}}">修改密码</router-link>
                    </span>
                    </el-dropdown-item>
                    <el-dropdown-item divided>
                        <span @click="logout" style="display:block;">退出登录</span>
                    </el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </el-row>
        <el-row class="thead-bg">
            <el-col>
                <!--<breadcrumb></breadcrumb>-->
            </el-col>
        </el-row>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import Breadcrumb from "~/widgets/Breadcrumb.vue";
    import Hamburger from "~/widgets/Hamburger.vue";
    import AccountService from "~/services/account";

    export default {
        data() {
            return {
                avatar: "",
            };
        },
        components: {
            Breadcrumb,
            Hamburger
        },
        computed: {
            ...mapGetters([
                "sidebar",
                //'avatar'
            ])
        },
        methods: {
            toggleSideBar() {
                this.$store.dispatch("ToggleSideBar");
            },
            logout() {
                this.$confirm("确定要注销登录吗?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                    .then(() => {
                        this.$store.dispatch("logout").then(() => {
                            location.reload(); // 为了重新实例化vue-router对象 避免bug
                        }).cache(err => {
                            console.log("logout err", err);
                        });
                    })
                    .catch(() => {
                        return;
                    });
            },
            goToProfile() {
                const userId = this.$store.getters.userId;
                if (userId > 0) {
                    this.$router.push({
                        path: "/user/view",
                        query: {
                            id: userId
                        }
                    });
                }
            }
        }
    };
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
    .navbar {
        height: 60px;
        background: #fff;
        border-bottom: 1px solid #f5f5f5;
        border-radius: 0px !important;
        .hamburger-container {
            height: 60px;
            line-height: 60px;
            float: left;
            padding: 0 20px;
        }
        .screenfull {
            position: absolute;
            right: 90px;
            top: 16px;
            color: red;
        }
        .avatar-container {
            height: 60px;
            top: 10px;
            display: inline-block;
            position: absolute;
            right: 35px;
            .avatar-wrapper {
                cursor: pointer;
                .user-avatar {
                    width: 40px;
                    height: 40px;
                    border-radius: 10px;
                }
                .el-icon-caret-bottom {
                    position: absolute;
                    right: -20px;
                    top: 16px;
                    font-size: 12px;
                }
            }
        }
        .msg-tip {
            margin-right: 70px;
            margin-top: 10px;
            .el-icon-message {
                font-size: 24px;
            }
        }
    }

    .thead-bg {
        background: #fff;
    }
</style>




// WEBPACK FOOTER //
// src/widgets/Navbar.vue